import {Component} from '@angular/core';

export interface OfferData {
  id: string;
  content: string;
}

@Component({
  selector: 'app-parking-offer',
  imports: [],
  templateUrl: './parking-offer.component.html',
  styleUrl: './parking-offer.component.scss'
})
export class ParkingOfferComponent {

  protected offerData: OfferData[] = [
    {
      id: "01",
      content: $localize`:@@autopark.offer-item-1.content:Plac w atrakcyjnej lokalizacji mieszczący 1500 samochodów`
    },
    {
      id: "02",
      content: $localize`:@@autopark.offer-item-2.content:Wybrukowana, utwardzona powierzchnia – bez ryzyka dla aut`
    },
    {
      id: "03",
      content: $localize`:@@autopark.offer-item-3.content:Ochrona 24/7 i monitoring – pełne bezpieczeństwo`
    },
    {
      id: "04",
      content: $localize`:@@autopark.offer-item-4.content:Szybki dostęp i wydanie aut na żądanie – elastyczna obsługa flot`
    },
    {
      id: "05",
      content: $localize`:@@autopark.offer-item-5.content:Możliwość dostosowania usług (np. dodatkowe zabezpieczenia, obsługa dokumentów wydania)`
    },
    {
      id: "06",
      content: $localize`:@@autopark.offer-item-6.content:Dopasowana logistyka, indywidualne warunki umowy`
    }
  ];
}
